<template>
  <div class="container text-center">
    <div class="contact__form">
      <h1>404</h1>
      <SvgIconNotFound></SvgIconNotFound>

      <h2>Oops, it looks like the page you're looking for doesn't exist.</h2>
      <GoBack></GoBack>
    </div>
  </div>
</template>

<script>
  import GoBack from "@/components/GoBack.vue"
  import SvgIconNotFound from "@/components/svg/SvgIconNotFound.vue"
  export default {
    name: "NotFound",
    components: {
      GoBack,
      SvgIconNotFound,
    },
  }
</script>

<style lang="scss"></style>
